import React from "react";
import { Purl } from "@sscs/types";
import { LongTextLabel } from "@sscs/ui";
import { parsePurl } from "@sscs/utils";
import Docker from "Assets/images/community/docker.svg";
import HuggingFace from "Assets/images/community/huggingface.svg";
import Maven from "Assets/images/community/maven.svg";
import Npm from "Assets/images/community/npm.svg";
import Nuget from "Assets/images/community/nuget.svg";
import Powershell from "Assets/images/community/powershell.svg";
import Pypi from "Assets/images/community/pypi.svg";
import Ruby from "Assets/images/community/rubygems.svg";
import VSCode from "Assets/images/community/vsc.svg";
import styles from "./urlmportForm.module.scss";

const COMMUNITY_NAME: Record<string, string> = {
  docker: "Docker",
  npm: "npm",
  nuget: "NuGet",
  gem: "RubyGems",
  psgallery: "PS Gallery",
  pypi: "PyPI",
  vsx: "VS Code",
  maven: "Maven",
  huggingface: "Hugging Face",
};

const COMMUNITY_ICON: Record<string, React.JSX.Element> = {
  docker: <Docker />,
  npm: <Npm />,
  nuget: <Nuget />,
  gem: <Ruby />,
  psgallery: <Powershell />,
  pypi: <Pypi />,
  vsx: <VSCode />,
  maven: <Maven />,
  huggingface: <HuggingFace />,
};

type CommunityProps = {
  purl: string;
};

const Community = ({ purl }: CommunityProps): React.JSX.Element | null => {
  let purlComponents: Purl;

  try {
    purlComponents = parsePurl(purl);
  } catch {
    return null;
  }

  let packageName = purlComponents.name;

  if (purlComponents.namespace) {
    packageName = `${purlComponents.namespace}/${purlComponents.name}`;
  }

  return (
    <div className={styles.card}>
      <div className={styles["community-title"]}>
        <LongTextLabel
          label={`${packageName} | ${purlComponents.version ?? "latest"}`}
        />
        <div className={styles["community-type"]}>
          {COMMUNITY_ICON[purlComponents.type]}
          {COMMUNITY_NAME[purlComponents.type] ?? purlComponents.type}
        </div>
      </div>
    </div>
  );
};

export default Community;
